import {
  getPdfProductTableList,
  getDiscountsEditionProductTableList,
  getProductListUnitPrices,
} from '@/helpers/productListHelpers/getProductTableList'
import {
  getProductListMaxDiscountsRates,
  getProductListStandardDiscountsRates,
} from '@/helpers/productListHelpers/getDiscountRates'
import { getProductListPivotProductPricingRules } from '@/helpers/productListHelpers/getProductListPricingRules'
import { getZoningRules } from '@/helpers/productListHelpers/getZoningRules'
import { OFFER_STATUS, VALIDATION_STATUS, SIGNATURE_TYPE } from '@/helpers/constants'

export const GET_OFFER_ITEM = 'GET_OFFER_ITEM'
export const GET_CONTRACT_MODEL = 'GET_CONTRACT_MODEL'
export const GET_DISCOUNTS_EDITION_PRODUCT_TABLE_LIST = 'GET_DISCOUNTS_EDITION_PRODUCT_TABLE_LIST'
export const GET_PDF_PRODUCT_TABLE_LIST = 'GET_PDF_PRODUCT_TABLE_LIST'
export const GET_PRODUCT_ID_LIST = 'GET_PRODUCT_ID_LIST'
export const GET_PRODUCT_TABLE = 'GET_PRODUCT_TABLE'
export const GET_PRODUCT = 'GET_PRODUCT'
export const GET_PRODUCT_WEIGHT_LIST = 'GET_PRODUCT_WEIGHT_LIST'
export const GET_PRODUCT_CURRENT_WEIGHT_LIST = 'GET_PRODUCT_CURRENT_WEIGHT_LIST'
export const GET_PRODUCT_STANDARD_WEIGHT_LIST = 'GET_PRODUCT_STANDARD_WEIGHT_LIST'
export const GET_PRODUCT_LIST_UNIT_PRICES = 'GET_PRODUCT_LIST_UNIT_PRICES'
const GET_PRODUCT_LIST_PIVOT_RULES = 'GET_PRODUCT_LIST_PIVOT_RULES'
export const GET_PRODUCT_PIVOT_RULES = 'GET_PRODUCT_PIVOT_RULES'
const GET_PRODUCT_LIST_MAX_DISCOUNT_RATES = 'GET_PRODUCT_LIST_MAX_DISCOUNT_RATES'
export const GET_PRODUCT_MAX_DISCOUNT_RATES = 'GET_PRODUCT_MAX_DISCOUNT_RATES'
const GET_PRODUCT_STD_DISCOUNT_RATES_LIST = 'GET_PRODUCT_STD_DISCOUNT_RATES_LIST'
export const GET_PRODUCT_STD_DISCOUNT_RATES = 'GET_PRODUCT_STD_DISCOUNT_RATES'

export default {
  [GET_OFFER_ITEM]: state => key => state.offer[key],

  // Modelo de contrato/PDF derivado del snapshot guardado en la propia oferta
  // (rateModelDesc.contractModel). Es la fuente fiable: no depende del rateModelId,
  // que puede quedar desactualizado si se reordenan los IDs de modelos tarifarios.
  // Como red de seguridad (p. ej. ofertas antiguas o mocks sin contractModel) se
  // recurre al modelo cargado en el módulo rateModel.
  [GET_CONTRACT_MODEL]: (state, _getters, rootState) =>
    state.offer.rateModelDesc?.contractModel ||
    state.offer.contractModel ||
    rootState.rateModel?.rateModel?.rateModelDesc?.contractModel ||
    null,

  canEditOffer: state =>
    state.offer.status !== OFFER_STATUS.VALIDATING &&
    state.offer.status !== OFFER_STATUS.SIGNING &&
    state.offer.status !== OFFER_STATUS.SIGNED &&
    !(state.offer.status === OFFER_STATUS.VALIDATED &&
      state.offer.validationStatus === VALIDATION_STATUS.PENDING),
  showUpdateOfferStatusButton: state => state.offer.status === OFFER_STATUS.VALIDATING,
  typeCOfferAllowed: state => !!state.offer.typeCOfferAllowed,
  hasBankGuarantee: state => !!state.offer.hasBankGuarantee,
  isManuallySigned: state =>
    state.offer.status === OFFER_STATUS.SIGNED &&
    state.offer.contract.signatureType === SIGNATURE_TYPE.MANUAL,

  [GET_DISCOUNTS_EDITION_PRODUCT_TABLE_LIST]: state =>
    getDiscountsEditionProductTableList(state.offer.productList),
  [GET_PRODUCT_ID_LIST]: (_, getters) =>
    Object.keys(getters[GET_DISCOUNTS_EDITION_PRODUCT_TABLE_LIST]),
  [GET_PRODUCT_TABLE]: (_, getters) => productId =>
    getters[GET_DISCOUNTS_EDITION_PRODUCT_TABLE_LIST][productId],

  [GET_PRODUCT]: state => productId =>
    state.offer.productList.find(product => product.id === productId),
  [GET_PRODUCT_WEIGHT_LIST]: (_, getters) => productId =>
    getters[GET_PRODUCT](productId).weightList.map(item => item.value),
  [GET_PRODUCT_CURRENT_WEIGHT_LIST]: (_, getters) => productId =>
    getters[GET_PRODUCT](productId).currentWeightIdList,
  [GET_PRODUCT_STANDARD_WEIGHT_LIST]: (_, getters) => productId =>
    getters[GET_PRODUCT](productId).standardWeightIdList,

  [GET_PRODUCT_LIST_UNIT_PRICES]: state => getProductListUnitPrices(state.offer.productList),
  [GET_PRODUCT_LIST_PIVOT_RULES]: state =>
    getProductListPivotProductPricingRules(state.offer.productList),
  [GET_PRODUCT_PIVOT_RULES]: (_, getters) => productId =>
    getters[GET_PRODUCT_LIST_PIVOT_RULES][productId],

  [GET_PRODUCT_LIST_MAX_DISCOUNT_RATES]: state =>
    getProductListMaxDiscountsRates(
      state.offer.productList,
      state.offer.clientCommitedDeliveries,
      state.offer.internationalShipments,
    ),
  [GET_PRODUCT_MAX_DISCOUNT_RATES]: (_, getters) => productId =>
    getters[GET_PRODUCT_LIST_MAX_DISCOUNT_RATES][productId],

  [GET_PRODUCT_STD_DISCOUNT_RATES_LIST]: state =>
    getProductListStandardDiscountsRates(
      state.offer.productList,
      state.offer.clientCommitedDeliveries,
      state.offer.internationalShipments,
    ),
  [GET_PRODUCT_STD_DISCOUNT_RATES]: (_, getters) => productId =>
    getters[GET_PRODUCT_STD_DISCOUNT_RATES_LIST][productId],

  [GET_PDF_PRODUCT_TABLE_LIST]: state =>
    getPdfProductTableList(state.offer.productList, state.offer.type),

  getZoningRules: state => productId => getZoningRules(state.offer.productList, productId),
}
